<template>
    <div class="index-wrap">
        <div class="swiper-container banner"  id="swiperContainer">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <img src="../../assets/img/index/banner3.jpg" class="banner-img phoneHide">
                    <img src="../../assets/img/index/banner-h5-3.jpg" class="banner-img pcHide">
                    <div class="banner-text">
                        <div class="title-big">東亞美食節指定支付合作商</div>
                        <div class="title-en">East Asia Food Jie appointed payment partner</div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <img src="../../assets/img/index/banner.jpg" class="banner-img phoneHide">
                    <img src="../../assets/img/index/banner-H5.jpg" class="banner-img pcHide">
                    <div class="banner-text">
                        <div class="title-desc">Wechat Pay、Alipay指定服務商</div>
                        <div class="title-big">香港金融持牌機構</div>
                        <div class="title-en">Hong Kong financial licensees,Wechat Pay,Alipay designated service provider </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <img src="../../assets/img/index/banner2.jpg" class="banner-img phoneHide">
                    <img src="../../assets/img/index/banner-h5-2.jpg" class="banner-img pcHide">
                    <div class="banner-text">
                        <div class="title-big">支持跨境支付 讓支付更簡單</div>
                        <div class="title-en">Support cross-border payments to make payments easier</div>
                    </div>
                </div>
            </div>
            <!-- <div class="swiper-button-prev swiper-button-white"></div>
            <div class="swiper-button-next swiper-button-white"></div> -->
            <div class="swiper-pagination"></div>
        </div>
        <div class="part part0">
            <div class="max-width">
                <div class="swiper-container1">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide"><img src="../../assets/img/index/partner1.jpg" class="partner-img"><p>第一家商戶“天天洗衣”</p></div>
                        <div class="swiper-slide"><img src="../../assets/img/index/partner2.jpg" class="partner-img"><p>合作商戶“醫纖美LUX”</p></div>
                        <div class="swiper-slide"><img src="../../assets/img/index/partner3.jpg" class="partner-img"><p>合作商戶“港安大藥房”</p></div>
                        <div class="swiper-slide"><img src="../../assets/img/index/partner4.jpg" class="partner-img"><p>合作商戶“SADA”</p></div>
                        <div class="swiper-slide"><img src="../../assets/img/index/partner5.jpg" class="partner-img"><p>合作商戶“28watches”</p></div>
                        <div class="swiper-slide"><img src="../../assets/img/index/partner6.jpg" class="partner-img"><p>合作商戶“黃潘陳羅律師行”</p></div>
                        <div class="swiper-slide"><img src="../../assets/img/index/partner7.jpg" class="partner-img"><p>合作商戶“WATCH ME”</p></div>
                        <div class="swiper-slide"><img src="../../assets/img/index/partner8.jpg" class="partner-img"><p>合作商戶“Queen Bridal”</p></div>
                        <div class="swiper-slide"><img src="../../assets/img/index/partner9.jpg" class="partner-img"><p>合作商戶“背景國楓律師事務所”</p></div>
                        <div class="swiper-slide"><img src="../../assets/img/index/partner10.jpg" class="partner-img"><p>合作商戶“KAYSTECH”</p></div>
                        <div class="swiper-slide"><img src="../../assets/img/index/partner11.jpg" class="partner-img"><p>合作商戶“Tai Ohhh”</p></div>
                        <div class="swiper-slide"><img src="../../assets/img/index/partner12.jpg" class="partner-img"><p>合作商戶“雲南記”</p></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="part part1">
            <div class="max-width">
                <div class="main-title">
                    <div class="title-cn">業務範圍</div>
                    <div class="title-en">普利互聯網業務範圍</div>
                </div>
                <div class="main-content">
                    <div class="listBox">
                        <img src="../../assets/img/index/icon1.png" class="img-icon">
                        <div class="title">Wish  Pay</div>
                        <div class="desc">多碼合一，多種支付<br class="phoneHide"/>提交資料，我們操作，極速認證</div>
                    </div>
                    <div class="listBox">
                        <img src="../../assets/img/index/icon2.png" class="img-icon">
                        <div class="title">代開公總號、小程序</div>
                        <div class="desc">最先進付款方式，資金馬上到賬<br class="phoneHide"/>更有語音播報提示功能</div>
                    </div>
                    <div class="listBox">
                        <img src="../../assets/img/index/icon3.png" class="img-icon">
                        <div class="title">代開銀行收款</div>
                        <div class="desc">現在入駐，享受最優惠的費率<br class="phoneHide"/>還有各種優惠支付補貼</div>
                    </div>
                    <div class="listBox">
                        <img src="../../assets/img/index/icon4.png" class="img-icon">
                        <div class="title">小程序、公眾號定制開發</div>
                        <div class="desc">減少服務人員操作，提高收款效率<br class="phoneHide"/>收銀台無需排隊
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="part part2" id="part2">
            <div class="max-width">
                <div class="main-title">
                    <div class="title-cn">定制開發</div>
                    <div class="title-en">專業的定制團隊</div>
                </div>
                <div class="main-content">
                    <div class="list-box">
                        <img src="../../assets/img/index/solution1.jpg" class="solution-img phoneHide">
                        <img src="../../assets/img/index/solution1.png" class="solution-img pcHide">
                        <div class="text-box">
                            <div class="title">- 多種收銀 -</div>
                            <div class="desc">QR Code收款,付款碼收款,支持Wechat Pay、Alipay 等多種支付方式,支持手機和POS收款,全方位滿足商家收款！</div>
                        </div>
                    </div>
                    <div class="list-box">
                        <img src="../../assets/img/index/solution2.jpg" class="solution-img phoneHide">
                        <img src="../../assets/img/index/solution2.png" class="solution-img pcHide">
                        <div class="text-box">
                            <div class="title">- 數據與統計 -</div>
                            <div class="desc">商戶管理、數據分析、支付流水查詢。不同週期的業務分析,隨時隨地了解門店交易情況。</div>
                        </div>
                    </div>
                    <div class="list-box">
                        <img src="../../assets/img/index/solution3.jpg" class="solution-img phoneHide">
                        <img src="../../assets/img/index/solution3.png" class="solution-img pcHide">
                        <div class="text-box">
                            <div class="title">- 高效結算 -</div>
                            <div class="desc">及時向商戶結算，部分節假日親算，保障資金到賬時效。</div>
                        </div>
                    </div>
                    <div class="list-box">
                        <img src="../../assets/img/index/solution4.jpg" class="solution-img phoneHide">
                        <img src="../../assets/img/index/solution4.png" class="solution-img pcHide">
                        <div class="text-box">
                            <div class="title">- 專業定制服務 -</div>
                            <div class="desc">為商戶定制打造屬於自己的Wechat公眾號,構建網上流量入口,精準進行高效化營銷。</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- pc端商戶下載 -->
        <div class="part part3 hide phoneHide" id="part3">
            <div class="max-width">
                <div class="main-title">
                    <div class="title-cn">如意⽀付商戶APP</div>
                    <div class="title-en">Wish Pay merchant APP</div>
                </div>
                <div class="main-content">
                    <img src="../../assets/img/index/merchant_app.png" class="merchant-app">
                    <div class="load-box"  >
                        <div class="load-btn" @mouseenter="merchantIos=true" @mouseleave="merchantIos=false">
                            <img src="../../assets/img/index/ios.png" class="load-img">
                            <div class="load-right">
                                <div class="load-text">立即下載</div>
                                <div class="load-desc">iPhone客戶端</div>
                            </div>
                            <div class="load-code" v-if="merchantIos">
                                <div class="arrow"></div>
                                <img src="../../assets/img/index/merchant_code_and.png" class="load-code-img">
                                <div class="load-text">掃描QR Code下載APP</div>
                            </div>
                        </div>
                        <div class="load-btn" @mouseenter="merchantAnd = true" @mouseleave="merchantAnd=false">
                            <img src="../../assets/img/index/and.png" class="load-img">
                            <div class="load-right">
                                <div class="load-text">立即下載</div>
                                <div class="load-desc">Android客戶端</div>
                            </div>
                            <div class="load-code" v-if="merchantAnd">
                                <div class="arrow"></div>
                                <img src="../../assets/img/index/merchant_code_and.png" class="load-code-img">
                                <div class="load-text">掃描QR Code下載APP</div>
                            </div>
                        </div>
                    </div>
                    <div class="listBox listBox1" :class="{'merchant-active':merchantActive==1}" @mouseenter="changeActive(1)" @mouseleave="removeActive(1)">
                        <span class="arrow"></span>
                        <img src="../../assets/img/index/merchant_app_hover1.png" v-if="merchantActive==1" class="img-icon">
                        <img src="../../assets/img/index/merchant_app1.png" v-else class="img-icon">
                        <div class="title">掃碼收款</div>
                    </div>
                    <div class="listBox listBox2" :class="{'merchant-active':merchantActive==2}" @mouseenter="changeActive(2)" @mouseleave="removeActive(2)">
                        <span class="arrow"></span>
                        <img src="../../assets/img/index/merchant_app_hover2.png" v-if="merchantActive==2" class="img-icon">
                        <img src="../../assets/img/index/merchant_app2.png" v-else class="img-icon">
                        <div class="title">資料管理</div>
                    </div>
                    <div class="listBox listBox3" :class="{'merchant-active':merchantActive==3}" @mouseenter="changeActive(3)" @mouseleave="removeActive(3)">
                        <span class="arrow"></span>
                        <img src="../../assets/img/index/merchant_app_hover3.png" v-if="merchantActive==3" class="img-icon">
                        <img src="../../assets/img/index/merchant_app3.png" v-else class="img-icon">
                        <div class="title">收入分析</div>
                    </div>
                    <div class="listBox listBox4" :class="{'merchant-active':merchantActive==4}" @mouseenter="changeActive(4)" @mouseleave="removeActive(4)">
                        <span class="arrow"></span>
                        <img src="../../assets/img/index/merchant_app_hover4.png" v-if="merchantActive==4" class="img-icon">
                        <img src="../../assets/img/index/merchant_app4.png" v-else class="img-icon">
                        <div class="title">運營報表</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 手機端商戶下載 -->
        <div class="part part3 pcHide">
            <div class="max-width">
                <div class="main-title">
                    <div class="title-cn">如意⽀付商戶APP</div>
                    <div class="title-en">Wish Pay merchant APP</div>
                </div>
                <div class="main-content">
                    <img src="../../assets/img/index/merchant_app.png" class="merchant-app">
                    <div class="listBox listBox1">
                        <span class="arrow"></span>
                        <img src="../../assets/img/index/merchant_app1.png" class="img-icon">
                        <div class="title">掃碼收款</div>
                    </div>
                    <div class="listBox listBox2">
                        <span class="arrow"></span>
                        <img src="../../assets/img/index/merchant_app2.png" class="img-icon">
                        <div class="title">資料管理</div>
                    </div>
                    <div class="listBox listBox3">
                        <span class="arrow"></span>
                        <img src="../../assets/img/index/merchant_app3.png" class="img-icon">
                        <div class="title">收入分析</div>
                    </div>
                    <div class="listBox listBox4">
                        <span class="arrow"></span>
                        <img src="../../assets/img/index/merchant_app4.png" class="img-icon">
                        <div class="title">運營報表</div>
                    </div>
                </div>
                <div  class="load-box" @click="loadUrl(merchantAndroidUrl,$event)">Android下載</div>
                <div  class="load-box" @click="loadUrl(merchantIOSUrl,$event)">iPhone下載</div>
            </div>
        </div>
        <!-- PC端代理下載 -->
        <div class="part part4 hide phoneHide" id="part4">
            <div class="max-width">
                <div class="main-title">
                    <div class="title-cn">如意⽀付代理商APP</div>
                    <div class="title-en">Wish Pay agent APP</div>
                </div>
                <div class="main-content">
                    <div class="agent-left">
                        <img src="../../assets/img/index/agent_app.png" class="agent-app">
                    </div>
                    <div class="agent-right">
                        <div class="agent-list">
                            <div class="listBox listBox1" :class="{'agent-active':agentActive==1}" @mouseenter="changeAgent(1)" @mouseleave="removeAgent(1)">
                                <img src="../../assets/img/index/agent_app_hover1.png" v-if="agentActive==1" class="img-icon">
                                <img src="../../assets/img/index/agent_app1.png" v-else class="img-icon">
                                <div class="title">發展商戶</div>
                            </div>
                            <div class="listBox listBox2" :class="{'agent-active':agentActive==2}" @mouseenter="changeAgent(2)" @mouseleave="removeAgent(2)">
                                <img src="../../assets/img/index/agent_app_hover2.png" v-if="agentActive==2" class="img-icon">
                                <img src="../../assets/img/index/agent_app2.png" v-else class="img-icon">
                                <div class="title">管理商戶</div>
                            </div>
                            <div class="listBox listBox3" :class="{'agent-active':agentActive==3}" @mouseenter="changeAgent(3)" @mouseleave="removeAgent(3)">
                                <img src="../../assets/img/index/agent_app_hover3.png" v-if="agentActive==3" class="img-icon">
                                <img src="../../assets/img/index/agent_app3.png" v-else class="img-icon">
                                <div class="title">分潤查詢</div>
                            </div>
                            <div class="listBox listBox4" :class="{'agent-active':agentActive==4}" @mouseenter="changeAgent(4)" @mouseleave="removeAgent(4)">
                                <img src="../../assets/img/index/agent_app_hover4.png" v-if="agentActive==4" class="img-icon">
                                <img src="../../assets/img/index/agent_app4.png" v-else class="img-icon">
                                <div class="title">結算管理</div>
                            </div>
                        </div>
                        <div class="load-box">
                            <div class="load-btn" @mouseenter="agentAnd = true" @mouseleave="agentAnd=false">
                                <img src="../../assets/img/index/and.png" class="load-img">
                                <div class="load-right">
                                    <div class="load-text">立即下載</div>
                                    <div class="load-desc">Android客戶端</div>
                                </div>
                                <div class="load-code" v-if="agentAnd">
                                    <div class="arrow"></div>
                                    <img src="../../assets/img/index/agent_code_and.png" class="load-code-img">
                                    <div class="load-text">掃描QR Code下載APP</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!-- 手機端代理下載 -->
        <div class="part part4 pcHide">
            <div class="max-width">
                <div class="main-title">
                    <div class="title-cn">如意⽀付代理商APP</div>
                    <div class="title-en">Wish Pay agent APP</div>
                </div>
                <div class="main-content">
                    <div class="agent-left">
                        <img src="../../assets/img/index/agent_app.png" class="agent-app">
                    </div>
                    <div class="agent-right">
                        <div class="agent-list">
                            <div class="listBox listBox1">
                                <img src="../../assets/img/index/agent_app1.png" class="img-icon">
                                <div class="title">發展商戶</div>
                            </div>
                            <div class="listBox listBox2">
                                <img src="../../assets/img/index/agent_app2.png" class="img-icon">
                                <div class="title">管理商戶</div>
                            </div>
                            <div class="listBox listBox3">
                                <img src="../../assets/img/index/agent_app3.png" class="img-icon">
                                <div class="title">分潤查詢</div>
                            </div>
                            <div class="listBox listBox4">
                                <img src="../../assets/img/index/agent_app4.png" class="img-icon">
                                <div class="title">結算管理</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div  class="load-box" @click="loadUrl(agentAndroidUrl,$event)">Android下載</div>
            </div>
        </div>
        <div class="part part5">
            <div class="max-width">
                <div class="main-title">
                    <div class="title-cn">優秀企業都在使用Wish Pay</div>
                    <div class="title-en">支付收款快人一步</div>
                </div>
                <div class="main-content">
                    <img src="../../assets/img/index/company1.png" class="company-img">
                    <img src="../../assets/img/index/company2.png" class="company-img">
                    <img src="../../assets/img/index/company3.png" class="company-img">
                    <img src="../../assets/img/index/company4.png" class="company-img">
                    <img src="../../assets/img/index/company5.png" class="company-img">
                    <img src="../../assets/img/index/company6.png" class="company-img">
                    <img src="../../assets/img/index/company7.png" class="company-img">
                    <img src="../../assets/img/index/company8.png" class="company-img">
                    <img src="../../assets/img/index/company9.png" class="company-img">
                    <img src="../../assets/img/index/company10.png" class="company-img">
                    <img src="../../assets/img/index/company11.png" class="company-img">
                    <img src="../../assets/img/index/company12.png" class="company-img">
                </div>
            </div>
        </div>
        <!-- 手机端下载提示 -->
        <div class="wxtip" id="JweixinTip" v-show="alertShow" @click="alertShow=false">
            <img src="@/assets/img/right.png" class="wxtip-icon">
            <!-- <span class="wxtip-icon"></span> -->
            <p class="wxtip-txt">點擊右上角<br/>選擇在瀏覽器中打開</p>
        </div>
    </div>
</template>
<script>
import {httpAnon, httpUser, api_type, getloadUrl} from '../../assets/js/api'
import util from '../../assets/js/util'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
export default {
  name: 'index',
  data () {
    return {
      screenWidth: document.body.clientWidth, // 这里是给到了一个默认值 （这个很重要）
      merchantActive: null,
      agentActive: null,
      merchantIos: false,
      merchantAnd: false,
      agentIos: false,
      agentAnd: false,
      agentAndroidUrl: '',
      agentIOSUrl: '',
      merchantAndroidUrl: '',
      merchantIOSUrl: '',
      alertShow: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)

    // const that = this;
    // window.onresize = () => {
    //     return (() => {
    //         window.screenWidth = document.body.clientWidth
    //         that.screenWidth = window.screenWidth
    //     })()
    // }
    var swiper = new Swiper('.swiper-container', {
      autoplay: {
        delay: 5000// 5秒切换一次
      },
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
      // navigation: {
      //     nextEl: '.swiper-button-next',
      //     prevEl: '.swiper-button-prev',
      // },

    })
    if (document.body.clientWidth < 1024) {
      var mySwiper = new Swiper('.swiper-container1', {
        loop: true,
        slidesPerView: 'auto',
        loopedSlides: 12,
        slidesPerView: 2,
        autoplay: {
          delay: 3000, // 3秒切换一次
          disableOnInteraction: false
        }
      })
    } else {
      var mySwiper = new Swiper('.swiper-container1', {
        loop: true,
        slidesPerView: 'auto',
        loopedSlides: 12,
        slidesPerView: 4.5,
        autoplay: {
          delay: 3000, // 3秒切换一次
          disableOnInteraction: false
        }
      })
    }
    this.getloadUrl()
  },
  watch: {
    // screenWidth (val) {
    // 	if (val < 1024) {
    // 		this.$router.push('/indexH5');
    // 	}
    // 	// this.screenWidth = val
    // }
  },
  methods: {

    changeActive (index) {
      this.merchantActive = index
    },
    removeActive (index) {
      this.merchantActive = null
    },
    changeAgent (index) {
      this.agentActive = index
    },
    removeAgent (index) {
      this.agentActive = null
    },
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let part2 = document.getElementById('part2').offsetTop
      let part3 = document.getElementById('part3').offsetTop
      if (scrollTop > part2 - 100 && scrollTop < part3) {
        document.getElementById('part3').className = 'part part3 show phoneHide'
      } else if (scrollTop > part3) {
        document.getElementById('part4').className = 'part part4 show phoneHide'
      }
    },
    getloadUrl: function () {
      getloadUrl().then(res => {
        this.agentAndroidUrl = res.data.data.agentAndroidUrl
        this.agentIOSUrl = res.data.data.agentIOSUrl
        this.merchantAndroidUrl = res.data.data.merchantAndroidUrl
        this.merchantIOSUrl = res.data.data.merchantIOSUrl
      }).catch(err => {
        return this.$message.error(err.data.msg)
      })
    },
    loadUrl: function (url, sys) {
      if (url) {
        var ua = navigator.userAgent
        var isWeixin = !!/MicroMessenger/i.test(ua)
        var u = navigator.userAgent, app = navigator.appVersion
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // g
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
        if (isIOS) {
          window.location.href = url
        }
        if (isAndroid) {
          if (isWeixin) {
            this.alertShow = true
          } else {
            window.location.href = url
          }
        }
        // if(isWeixin){
        //     this.alertShow = true
        // }else{
        // //     var u = navigator.userAgent, app = navigator.appVersion;
        // //     var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        // //     var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        // //     if (isAndroid) {
        // //         if(sys=='and'){
        // //             window.location.href = url;
        // //         }else{
        // //             alert("請選擇符合您的操作系統的下載鏈接")
        // //         }
        // //     }
        // //     if (isIOS) {
        // // 　　　　if(sys=='ios'){
        // //             window.location.href = url;
        // //         }else{
        // //             alert("請選擇符合您的操作系統的下載鏈接")
        // //         }
        // //     }
        //     window.location.href = url;
        // }
      }
    }

  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }

}
</script>
<style lang="stylus" scoped>

.banner
    width 100%
    position relative
    margin-top 80px
    .banner-img
        width 100%
    .banner-text
        position absolute
        width 100%
        left 0
        top 50%
        transform translateY(-50%)
        color #fff
        text-align center
        .title-desc
            font-size 20px
        .title-big
            font-size 36px
            margin 10px 0 20px 0
        .title-en
            font-size 14px

.part0
    .max-width
        overflow hidden
        .swiper-slide
            text-align: center;
            width 255px
            position relative
            .partner-img
                width 255px
            p
                font-size 13px
                position absolute
                width 100%
                text-align center
                left 0
                bottom 0
                color #ffffff
                height 35px
                line-height 35px
                background rgba(0,0,0,0.2)

.part1
    .main-content
        display flex
        align-items center
        justify-content space-between
        flex-wrap wrap
        .listBox
            width 500px
            text-align center
            padding 20px 30px
            box-sizing border-box
            .img-icon
                width 180px
            .title
                color #2B2B2B
                font-size 18px
                margin 10px 0 20px 0
            .desc
                color #666666
                font-size 12px
                line-height 18px
.part2
    .main-content
        display flex
        align-items center
        justify-content space-between
        .list-box
            width 287.5px
            background #F6F6F6
            text-align center
            box-sizing border-box
            margin-top 5px
            position relative
            .solution-img
                width 100%
            .text-box
                position absolute
                width 100%
                left 0
                top 50%
                transform translateY(-50%)
                padding 0 50px
                box-sizing border-box
                .title
                    color #fff
                    font-size 24px
                .desc
                    color #fff
                    font-size 13px
                    line-height 24px
                    margin-top 60px
                    padding 0
                    min-height 1px
.part3
    .main-content
        position relative
        text-align center
        display block!important
        .merchant-app
            width 300px
        .load-box
            position absolute
            left 50%
            transform translateX(-50%)
            bottom 20px
            display flex
            .load-btn
                display flex
                align-items center
                background #F6AB11
                border-radius 20px
                padding 10px 20px
                margin 0 30px
                position relative
                .load-img
                    width 30px
                .load-right
                    font-size 12px
                    color #fff
                    margin-left 5px
                    .load-desc
                        margin-top 3px
                .load-code
                    background #ED6B1A
                    text-align center
                    padding 10px 20px
                    position absolute
                    left 120%
                    top -80%
                    z-index 1
                    .arrow
                        width 0
                        height 0
                        border-right 15px solid #ED6B1A
                        border-top 10px solid transparent
                        border-bottom 10px solid transparent
                        position absolute
                        left -14px
                        top 40%
                    .load-code-img
                        width 100px
                    .load-text
                        color #fff
                        margin-top 5px
                        font-size 12px
        .listBox
            position absolute
            background #fff
            display flex
            align-items center
            box-shadow 0 0 15px #dedede
            padding 15px 35px
            border-radius 20px
            .arrow
                width 0px
                height 0px
                position absolute
            .img-icon
                width 60px
            .title
                color #2B2B2B
                font-size 24px
                margin-left 20px
        .listBox1
            left 30px
            top 150px
            .arrow
                border-bottom 15px solid #fff
                border-right 15px solid transparent
                right -15px
                top 50%
        .listBox2
            right 30px
            top 150px
            .arrow
                border-bottom 15px solid #fff
                border-left 15px solid transparent
                left -15px
                top 50%
        .listBox3
            left 30px
            bottom 200px
            .arrow
                border-bottom 15px solid #fff
                border-right 15px solid transparent
                right -15px
                top 50%
        .listBox4
            right 30px
            bottom 200px
            .arrow
                border-bottom 15px solid #fff
                border-left 15px solid transparent
                left -15px
                top 50%
        .merchant-active
            background #ED6B1A
            .title
                color #fff
            .arrow
                border-bottom 15px solid #ED6B1A
.part4
    .main-title
        text-align center
        position relative
        padding 30px 0
    .main-content
        width 100%
        display flex
        margin-top 30px
        .agent-left
            width 450px
            .agent-app
                width 100%
        .agent-right
            flex 1
            margin-left 50px
            .agent-list
                display flex
                flex-wrap wrap
                .listBox
                    width 180px
                    background #fff
                    display flex
                    align-items center
                    box-shadow 0 0 15px #dedede
                    padding 15px 35px
                    margin 20px 30px
                    border-radius 20px
                    .arrow
                        width 0px
                        height 0px
                        position absolute
                    .img-icon
                        width 60px
                    .title
                        color #2B2B2B
                        font-size 24px
                        margin-left 20px
                .agent-active
                    background #ED6B1A
                    .title
                        color #fff
            .load-box
                display flex
                width 70%
                margin 80px auto 0
                .load-btn
                    display flex
                    align-items center
                    background #F6AB11
                    border-radius 20px
                    padding 10px 20px
                    margin 0 30px
                    position relative
                    .load-img
                        width 30px
                    .load-right
                        font-size 12px
                        color #fff
                        margin-left 5px
                        text-align center
                        .load-desc
                            margin-top 3px
                    .load-code
                        background #ED6B1A
                        text-align center
                        padding 10px 20px
                        position absolute
                        left 120%
                        top -80%
                        z-index 1
                        .arrow
                            width 0
                            height 0
                            border-right 15px solid #ED6B1A
                            border-top 10px solid transparent
                            border-bottom 10px solid transparent
                            position absolute
                            left -14px
                            top 40%
                        .load-code-img
                            width 100px
                        .load-text
                            color #fff
                            margin-top 5px
                            font-size 12px

.part5
    margin-bottom 30px
    .main-content
        display flex
        align-items center
        justify-content space-between
        flex-wrap wrap
        .company-img
            width 250px
            margin-bottom 20px

.wxtip
    display none

.hide{
    opacity: 0;
    -webkit-transform: translate3d(0,50px,0)
    -moz-transform: translate3d(0,50px,0)
    -ms-transform: translate3d(0,50px,0)
    -o-transform: translate3d(0,50px,0)
    transform: translate3d(0,50px,0)
}
.show{
    opacity: 1;
    -webkit-transform: translate3d(0,0,0)
    -moz-transform: translate3d(0,0,0)
    -ms-transform: translate3d(0,0,0)
    -o-transform: translate3d(0,0,0)
    transform: translate3d(0,0,0)
    transition: all 0.8s linear 0s;
}
@media screen and (max-width: 1024px)
    .banner
        margin-top 60px
        .banner-img
            width 100%
        .banner-text
            position absolute
            width 100%
            left 0
            top 50%
            transform translateY(-50%)
            color #fff
            text-align center
            .title-desc
                font-size 14px
            .title-big
                font-size 24px
                margin 10px 0 15px 0
            .title-en
                font-size 12px
                width 80%
                margin 0 auto

    .part0
        .max-width
            overflow hidden
            .swiper-slide
                width 50%
                .partner-img
                    width 100%
                p
                    font-size 12px
                    height 30px
                    line-height 30px
                    background rgba(0,0,0,0.2)

    .part1
        .main-content
            display flex
            align-items flex-start
            justify-content space-between
            flex-wrap wrap
            .listBox
                width 50%
                text-align center
                padding 10px 10px
                box-sizing border-box
                .img-icon
                    width 50%
                .title
                    font-size 15px
                    margin 5px 0 10px 0
                    line-height 24px
                .desc
                    font-size 12px
                    line-height 18px
    .part2
        .main-content
            display flex
            align-items center
            justify-content space-between
            flex-wrap wrap
            .list-box
                width 572px
                background #F6F6F6
                text-align center
                box-sizing border-box
                margin-top 5px
                position relative
                .solution-img
                    width 100%
                .back-box
                    width 100%
                    height 100%
                    background #ED6B1A
                    position absolute
                    left 0
                    top 0
                .text-box
                    position absolute
                    width 100%
                    left 0
                    top 50%
                    transform translateY(-50%)
                    padding 0 10%
                    box-sizing border-box
                    .title
                        color #fff
                        font-size 24px
                    .desc
                        color #fff
                        font-size 12px
                        line-height 18px
                        margin-top 10px
    .part3
        width 100%
        background #fff
        .main-content
            position relative
            text-align center
            .merchant-app
                width 30%
            .listBox
                position absolute
                background #fff
                display flex
                align-items center
                box-shadow 0 0 15px #dedede
                padding 10px 8px
                border-radius 10px
                .arrow
                    width 0px
                    height 0px
                    position absolute
                .img-icon
                    width 30px
                .title
                    color #2B2B2B
                    font-size 15px
                    margin-left 2px
            .listBox1
                left 0
                top 10%
                .arrow
                    border-bottom 8px solid #fff
                    border-right 8px solid transparent
                    right -8px
                    top 50%
            .listBox2
                right 0
                top 10%
                .arrow
                    border-bottom 8px solid #fff
                    border-left 8px solid transparent
                    left -8px
                    top 50%
            .listBox3
                left 0
                bottom 35%
                .arrow
                    border-bottom 8px solid #fff
                    border-right 8px solid transparent
                    right -8px
                    top 50%
            .listBox4
                right 0
                bottom 35%
                .arrow
                    border-bottom 8px solid #fff
                    border-left 8px solid transparent
                    left -8px
                    top 50%
            .merchant-active
                background #ED6B1A
                .title
                    color #fff
                .arrow
                    border-bottom 15px solid #ED6B1A
        .load-box
            width 41%
            margin 0 4%
            display inline-block
            background  #F6AB11
            font-size 15px
            color #fff
            text-align center
            padding 10px 0
            box-shadow 3px 3px 10px #F2B434
            border-radius 5px
            color #fff
    .part4
        width 100%
        background #fff
        .main-content
            width 100%
            display flex
            align-items center
            .agent-left
                flex 1
                .agent-app
                    width 100%
            .agent-right
                width 40%
                margin-left 10%
                .agent-list
                    display flex
                    flex-wrap wrap
                    .listBox
                        background #fff
                        display flex
                        align-items center
                        box-shadow 0 0 15px #dedede
                        padding 7px 15px
                        margin 7px 0
                        border-radius 10px
                        .arrow
                            width 0px
                            height 0px
                            position absolute
                        .img-icon
                            width 30px
                        .title
                            color #2B2B2B
                            font-size 15px
                            margin-left 5px
                    .agent-active
                        background #ED6B1A
                        .title
                            color #fff
        .load-box
            width 41%
            margin 50px 4%
            display inline-block
            background  #F6AB11
            font-size 15px
            color #fff
            text-align center
            padding 10px 0
            box-shadow 3px 3px 10px #F2B434
            border-radius 5px
            color #fff

    .part5
        margin-top 0px
        margin-bottom 30px
        .main-content
            display flex
            align-items center
            justify-content space-between
            flex-wrap wrap
            .company-img
                width 30%
                margin-bottom 15px

    .wxtip{display:block;background: rgba(0,0,0,0.8); text-align: center; position: fixed; left:0; top: 0; width: 100%; height: 100%; z-index: 999;}
    .wxtip-icon{width: 52px; height: 67px; display: block; position: absolute; right: 20px; top: 20px;color:#fff}
    .wxtip-txt{margin-top: 107px; color: #fff; font-size: 16px; line-height: 1.5;}
</style>
<style>
.swiper-container-horizontal>.swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction{
    bottom:20px
}
.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{
    width: 30px;
    height: 2px;
    border-radius: 0
}

/* .swiper-button-prev{
    left:18%
}
.swiper-button-next{
    right:18%
} */
</style>



// WEBPACK FOOTER //
// src/components/pc/index.vue